import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home"; // Eager: LCP/critical page
import { AuthProvider } from "./context/AuthContext";
import { SiteSettingsProvider } from "./context/SiteSettingsContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";

// Lazy-load non-critical routes so the initial JS bundle stays small.
const About = lazy(() => import("./pages/About"));
const PastorPage = lazy(() => import("./pages/PastorPage"));
const CommitteePage = lazy(() => import("./pages/CommitteePage"));
const BRCPage = lazy(() => import("./pages/BRCPage"));
const Ministries = lazy(() => import("./pages/Ministries"));
const MinistryDetail = lazy(() => import("./pages/MinistryDetail"));
const Events = lazy(() => import("./pages/Events"));
const Resources = lazy(() => import("./pages/Resources"));
const NehemiahProject = lazy(() => import("./pages/NehemiahProject"));
const Contact = lazy(() => import("./pages/Contact"));
const Gallery = lazy(() => import("./pages/Gallery"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminGallery = lazy(() => import("./pages/AdminGallery"));
const AdminLeadership = lazy(() => import("./pages/AdminLeadership"));
const AdminContact = lazy(() => import("./pages/AdminContact"));
const NotFound = lazy(() => import("./pages/NotFound"));

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="route-loading">
    <div className="h-10 w-10 rounded-full border-2 border-blue-200 border-t-blue-600 animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <SiteSettingsProvider>
          <Header />
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/about/pastor" element={<PastorPage />} />
              <Route path="/about/committee" element={<CommitteePage />} />
              <Route path="/about/brc" element={<BRCPage />} />
              <Route path="/ministries" element={<Ministries />} />
              <Route path="/ministries/:slug" element={<MinistryDetail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/nehemiah-project" element={<NehemiahProject />} />
              <Route path="/contact" element={<Contact />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/gallery"
                element={
                  <ProtectedRoute>
                    <AdminGallery />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/leadership"
                element={
                  <ProtectedRoute>
                    <AdminLeadership />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/contact"
                element={
                  <ProtectedRoute>
                    <AdminContact />
                  </ProtectedRoute>
                }
              />

              {/* 404 catch-all — must be last */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <Footer />
          <Toaster position="top-right" />
            </SiteSettingsProvider>
        </AuthProvider>
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
